import {
  curveBasis,
  curveCatmullRom,
  curveLinear,
  curveMonotoneX,
  curveNatural,
  curveStep,
} from "@visx/curve";

export type CurveName =
  | "natural"
  | "monotone-x"
  | "linear"
  | "step"
  | "basis"
  | "catmull-rom";

const CURVE_MAP = {
  natural: curveNatural,
  "monotone-x": curveMonotoneX,
  linear: curveLinear,
  step: curveStep,
  basis: curveBasis,
  "catmull-rom": curveCatmullRom,
} as const;

export function resolveCurve(name?: CurveName) {
  return CURVE_MAP[name ?? "natural"];
}
